import { MediaData } from "@ts/data/MediaData";
import { api } from "../core/api";
import { Elements } from "../core/Elements";
import { Utils } from "../core/Utils";
import { EditBorder } from "./EditBorder";
import { EditTools } from "./EditTools";
import { SectionInterface } from "./Section";
import { HtmlData } from "@ts/data/HtmlData";
import { StreamsData } from "@ts/data/StreamsData";
import { Cookie } from "@ts/core/Cookie";
import { ImagesData } from "@ts/data/ImagesData";

export interface SectionHelp {
    title: string;
    text: string;
}

export abstract class AbstractSection  {

    // SectionInterface
    data:MediaData|HtmlData|StreamsData|ImagesData;
    
    // Self
    protected renderTarget: HTMLElement;
    protected sectionElement: HTMLElement;
    protected tbar: EditTools | null = null;
    private editEnabled: boolean = false;
    private editActive: boolean = false;
    private editBorder: EditBorder | null = null;
    protected pageName: string = '';
    
    // Accessors
    public get sectionElementRef(): HTMLElement { return this.sectionElement; }
    public get renderTargetRef(): HTMLElement { return this.renderTarget; }
    public get isEditEnabled(): boolean { return this.editEnabled; }
    public set enableEdit(v: boolean) { this.editEnabled = v; }
    public get isEditActive(): boolean { return this.editActive; }
    public set activeEdit(v: boolean) { this.editActive = v; }
    
    public set isPublic(v: boolean) { 
        (this.data as SectionInterface).public = v;
        api<void>('updateSectionPublic', {
            id: (this.data as SectionInterface).sectionid,
            public: (this.data as SectionInterface).public
        });
    }
    public get isPublic() : boolean { return (this.data as SectionInterface).public; }

    // Abstracts
    protected abstract onViewRender(): void;
    protected abstract onEditRender(): void; // Note! Never call onViewRender() or onEditRender() directly, use render() instead
    protected abstract parseContent(): void;

    // Construction
    public constructor(data:MediaData|HtmlData|StreamsData|ImagesData ) {
        
        this.data = data;
        this.pageName = Cookie.pagename;
        
        this.sectionElement = document.createElement('section');
        this.renderTarget = document.createElement('div');
        this.renderTarget.className = 'content';
        this.sectionElement.appendChild(this.renderTarget);
        
    }

    public async save(): Promise<void> {
        this.parseContent();
        await api<void>('updateSection', {
            id: this.data.sectionid,
            type: this.data.sectiontype,
            data: this.data
        });
    }

    public render(): void {
        if( document.getElementById(`${this.data.sectionid}`) === null ) {
            Elements.contentContainer.appendChild(this.sectionElement);
        }

        this.sectionElement.id = `${this.data.sectionid}`;
        if (this.editEnabled) {
            
            this.editBorder = new EditBorder(this);
            this.editBorder.render();
            if (this.editActive) {
                this.onEditRender();
            }
            else {
                this.onViewRender();
            }
        }
        else if( this.data.public ) {
            this.onViewRender();
        }
    }

    public beginEdit(): void {
        this.activeEdit = true;

        Utils.overlay(true);
        this.sectionElement.classList.add('edit');
        this.sectionElement?.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest", });
        this.tbar = new EditTools(this);
        this.render();
    }

    public endEdit(): void {
        Utils.overlay(false);
        
        if (this.tbar) this.tbar.close();

        
        this.sectionElement.classList.remove('edit');
        this.sectionElement.removeEventListener('mouseover', () => { });
        this.activeEdit = false;
        
        this.render();
    }

    public async delete(): Promise<void> {
        this.editBorder?.close();
        this.endEdit();
        await api<void>('deleteSection', { id: this.data.sectionid });
        Elements.contentContainer.removeChild( this.sectionElement );
    }




}